import VanillaTilt from 'vanilla-tilt';
import { isMobile } from '../common/DeviceHelper';

const initTilt = (node, speed, max, easing, mouseEventNode, perspective) => {
	VanillaTilt.init(node, {
		speed,
		max,
		easing,
		'mouse-event-element': mouseEventNode,
		perspective,
	});
};

function init() {
	const ANIMATION_SPEED = 1000;
	const MAX_TILT_ROTATION = 10;
	const EASING = 'cubic-bezier(0.3, 0, 0.4, 1)';
	const PERSPECTIVE = 500;

	const heroNodes = document.querySelectorAll('[data-services-hero]');

	if ((heroNodes && heroNodes.length === 0) || isMobile.matches) return;

	heroNodes.forEach(node => {
		let isInViewport = true;

		const titleNode = node.querySelector('[data-services-title]');
		const moseEvenetNode = node.querySelector(
			'[data-services-mouse-event-element]'
		);

		if (!titleNode || !moseEvenetNode) return;

		initTilt(
			titleNode,
			ANIMATION_SPEED,
			MAX_TILT_ROTATION,
			EASING,
			moseEvenetNode,
			PERSPECTIVE
		);

		const observer = new IntersectionObserver(
			entries => {
				isInViewport = entries[0].isIntersecting;

				if (!isInViewport) {
					titleNode.vanillaTilt.destroy();
				} else {
					initTilt(
						titleNode,
						ANIMATION_SPEED,
						MAX_TILT_ROTATION,
						EASING,
						moseEvenetNode,
						PERSPECTIVE
					);
				}
			},
			{ threshold: 0.1 }
		);

		observer.observe(node);
	});
}

export default init;
